<template>
  <transition name="fade">
    <div v-if="show" class="select-auto">
      <div
        class="absolute w-screen h-screen bg-black opacity-70 inset-0 z-10"
        @click="modalStore.toggleModal(ModalType.Login)"
      />
      <div
        class="absolute inset-0 w-screen h-screen flex items-center justify-center"
      >
        <div
          class="w-screen mx-2 xl:min-w-[800px] max-w-4xl p-4 relative xl:mx-auto my-auto shadow-lg bg-white z-10"
        >
          <div>
            <form class="text-center" @submit.prevent="handleLogin">
              <h2 class="text-3xl font-bold text-black mb-2">
                My Studio Login
              </h2>
              <p class="text-center mb-6">
                Simply enter an email address to save<br />
                all your designs in one place!
              </p>
              <div class="relative mb-4">
                <input
                  ref="emailInput"
                  v-model="loginEmail"
                  type="email"
                  aria-label="Enter your email"
                  placeholder="Enter your email"
                  class="block w-full border border-gray-300 p-3 pr-10"
                />
                <div class="absolute right-3 top-1/2 -translate-y-1/2">
                  <i class="fas fa-envelope text-pink-500" />
                </div>
              </div>
              <button
                type="submit"
                aria-label="Log in"
                class="block w-full bg-white border-2 border-black px-5 py-3 text-black text-lg font-medium relative rounded-full hover:bg-gray-50 transition-colors"
                :disabled="userStore.isLoading"
              >
                <span v-if="!userStore.isLoading">Log in</span>
                <span v-else class="flex items-center justify-center">
                  <i class="fas fa-spinner fa-spin mr-2" /> Loading...
                </span>
              </button>
              <continue-without-saving
                v-if="options?.continueWithoutSaving"
                :action="
                  () => {
                    if (options?.onContinueWithoutSaving) {
                      options.onContinueWithoutSaving();
                    }
                    modalStore.toggleModal(ModalType.Login);
                  }
                "
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed, ref, watch } from "vue"
import { ModalType, useModalStore } from "~/stores/modal"
import { useUserStore } from "~/stores/user"

const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
  callbackFn: {
    type: Function,
    required: false,
    default: () => {},
  },
});

const loginEmail = ref("");
const emailInput = ref(null);
const userStore = useUserStore();
const modalStore = useModalStore();

const options = computed(() => modalStore.getModalOptions(ModalType.Login));

watch(
  () => props.show,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        emailInput.value?.focus();
      });
    }
  },
  { immediate: true }
);

const handleLogin = async () => {
  if (!loginEmail.value) return;

  userStore.isLoading = true;

  try {
    await userStore.login(loginEmail.value);
    loginEmail.value = "";
    modalStore.handleSuccess(ModalType.Login);
  } catch (error) {
    console.error("Login failed:", error);
    modalStore.toggleModal(ModalType.Login);
  }
};
</script>

<style scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms ease-out;
}
</style>
